// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  background-color: #FDFDFD;
}

.event-menu .tippy-box {
  margin: 0 !important;
  background-color: #FDFDFD !important;
}
.event-menu .tippy-box .tippy-arrow {
  color: #FDFDFD !important;
}
.event-menu .tippy-box .tippy-content {
  padding: 0 !important;
}

.payout-modal .modal-container {
  width: 480px !important;
  height: 784px !important;
}
.payout-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding-bottom: 1.5rem !important;
}
.payout-modal .modal-container .modal-content {
  overflow: auto;
  padding-top: 0 !important;
}

.secondary-cta-hidden .secondary-cta {
  display: none;
}

.payout-title .secondary {
  border: 1px solid #E7E7E7;
}

.cant-modal .modal-container {
  width: 380px !important;
  height: 336px !important;
}
.cant-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.cant-modal .modal-container .modal-content {
  overflow: auto;
  padding-bottom: 32px !important;
}
.cant-modal .secondary-cta-hidden .secondary-cta {
  display: none;
}

.icon-circle {
  background: rgba(217, 45, 32, 0.1) !important;
}

.secondary-cta-hidden .secondary-cta {
  display: none;
}

.edit-bio .modal-container {
  width: 580px !important;
  height: 452px !important;
}
.edit-bio .modal-container .modal-header {
  border-bottom: 0 !important;
  padding-bottom: 1.5rem !important;
}
.edit-bio .modal-container .modal-content {
  overflow: auto;
  padding-top: 0 !important;
}

.details-edit .modal-container {
  width: 580px !important;
  height: 552px !important;
}
.details-edit .modal-container .modal-header {
  border-bottom: 0 !important;
  padding-bottom: 1.5rem !important;
}
.details-edit .modal-container .modal-content {
  overflow: auto;
  padding-top: 0 !important;
}

.edit-aadhar .modal-container {
  width: 480px !important;
  height: 345px !important;
}
.edit-aadhar .modal-container .modal-header {
  border-bottom: 0 !important;
  padding-bottom: 1.5rem !important;
}
.edit-aadhar .modal-container .modal-content {
  overflow: auto;
  padding-top: 0 !important;
}

@media screen and (max-width: 650px) {
  .payout-modal .modal-container {
    width: 343px !important;
    height: 732px !important;
    min-height: none !important;
  }
  .payout-modal .modal-footer {
    padding: 24px !important;
    padding-top: 0 !important;
  }
  .payout-modal .side-bar {
    display: none !important;
  }
}
@media screen and (max-width: 768px) {
  .side-bar {
    display: none !important;
  }
  .page-container > .content {
    padding: 24px !important;
    padding-top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/event-list/style.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEE;EACE,oBAAA;EACA,oCAAA;AACJ;AAAI;EACE,yBAAA;AAEN;AAAI;EACE,qBAAA;AAEN;;AAIE;EACE,uBAAA;EACA,wBAAA;AADJ;AAEI;EACG,2BAAA;EACA,iCAAA;AAAP;AAEI;EACC,cAAA;EACA,yBAAA;AAAL;;AAIA;EACE,aAAA;AADF;;AAIE;EACE,yBAAA;AADJ;;AAME;EACE,uBAAA;EACA,wBAAA;AAHJ;AAII;EACG,2BAAA;EACA,qBAAA;AAFP;AAII;EACC,cAAA;EACA,+BAAA;AAFL;AAKA;EACE,aAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAKA;EACE,aAAA;AAFF;;AAME;EACC,uBAAA;EACA,wBAAA;AAHH;AAIG;EACG,2BAAA;EACA,iCAAA;AAFN;AAKG;EACC,cAAA;EACA,yBAAA;AAHJ;;AASI;EACC,uBAAA;EACA,wBAAA;AANL;AAQK;EACG,2BAAA;EACA,iCAAA;AANR;AAUK;EACC,cAAA;EACA,yBAAA;AARN;;AAaM;EACC,uBAAA;EACA,wBAAA;AAVP;AAWO;EACG,2BAAA;EACA,iCAAA;AATV;AAYO;EACC,cAAA;EACA,yBAAA;AAVR;;AAgBA;EAEI;IACE,uBAAA;IACA,wBAAA;IACA,2BAAA;EAdJ;EAiBE;IACE,wBAAA;IACA,yBAAA;EAfJ;EAkBE;IACE,wBAAA;EAhBJ;AACF;AAoBA;EACK;IACC,wBAAA;EAlBJ;EAoBG;IACC,wBAAA;IACA,yBAAA;EAlBJ;AACF","sourcesContent":[".page-container{\n  background-color: theme('colors.white');\n}\n.event-menu{  \n  .tippy-box {\n    margin: 0 !important;\n    background-color: theme('colors.white') !important;\n    .tippy-arrow{\n      color:theme('colors.white') !important;\n    }\n    .tippy-content{\n      padding:0 !important;\n    }\n  }\n}\n\n.payout-modal{\n  .modal-container {\n    width: 480px !important;\n    height: 784px !important;\n    .modal-header{\n       border-bottom:0 !important;\n       padding-bottom:1.5rem !important;\n       }\n    .modal-content {\n     overflow: auto;\n     padding-top:0 !important;\n   }\n}\n}\n.secondary-cta-hidden .secondary-cta{\n  display: none;\n}\n.payout-title{\n  .secondary{\n    border: 1px solid theme('colors.grey-30');\n  }\n}\n\n.cant-modal{\n  .modal-container {\n    width: 380px !important;\n    height: 336px !important;\n    .modal-header{\n       border-bottom:0 !important;\n       padding:0 !important;\n       }\n    .modal-content {\n     overflow: auto;\n     padding-bottom:32px !important;\n   }\n}\n.secondary-cta-hidden .secondary-cta{\n  display: none;\n}\n}\n.icon-circle{\n  background:rgba(217, 45, 32, 0.10) !important;\n}\n.secondary-cta-hidden .secondary-cta{\n  display: none;\n}\n\n.edit-bio {\n  .modal-container {\n   width: 580px !important;\n   height: 452px !important;\n   .modal-header{\n      border-bottom:0 !important;\n      padding-bottom:1.5rem !important;\n\n   }\n   .modal-content {\n    overflow: auto;\n    padding-top:0 !important;\n  }\n   }\n  }\n\n  .details-edit {\n    .modal-container {\n     width: 580px !important;\n     height: 552px !important;\n\n     .modal-header {\n        border-bottom:0 !important;\n        padding-bottom:1.5rem !important;\n  \n     }\n    \n     .modal-content {\n      overflow: auto;\n      padding-top: 0 !important;\n      }\n    }\n  }\n    .edit-aadhar {\n      .modal-container {\n       width: 480px !important;\n       height: 345px !important;\n       .modal-header{\n          border-bottom:0 !important;\n          padding-bottom:1.5rem !important;\n    \n       }\n       .modal-content {\n        overflow: auto;\n        padding-top:0 !important;\n      }\n       }\n      }\n  \n\n@media screen and (max-width: 650px) {\n  .payout-modal{\n    .modal-container {\n      width: 343px !important;\n      height: 732px !important;\n      min-height: none !important;\n    }\n\n    .modal-footer{\n      padding: 24px !important;\n      padding-top: 0 !important;\n    }\n\n    .side-bar{\n      display: none !important;\n    }\n}\n}\n\n@media screen and (max-width: 768px) {\n     .side-bar{\n      display: none !important;\n     }\n     .page-container > .content {\n      padding: 24px !important;\n      padding-top: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
